import { apiInstance } from "./networking";
 
export const sendCkycOtp = async (payload) => {
  const { data = {} } = await apiInstance.post(`/V2/primary/ckyc-otp`, payload);
  return data;
};